import { Box, Stack, Typography } from "@mui/material";

const Scholarship = () => {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="right"
        justifyContent="right"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
      >
        <Typography fontSize={16}><b>
          A. Students can take a look at MAHADBT website for the scholarships. Under the following categories the student can look for the scholarship according to their requirement and field & apply accordingly through MAHADBT portal.
        </b>
        </Typography>
        <Typography fontSize={16}>
          1) Social Justice and Special Assistance Department
        </Typography>
        <Typography fontSize={16}>
          2) Tribal Development Department
        </Typography>
        <Typography fontSize={16}>
          3) Directorate of Higher Education
        </Typography>
        <Typography fontSize={16}>
          4) Directorate of Technical Education
        </Typography>
        <Typography fontSize={16}>
          5) OBC, SEBC, VJNT & SBC Welfare Department
        </Typography>
        <Typography fontSize={16}>
          6) Directorate of Medical Education and Research
        </Typography>
        <Typography fontSize={16}>
          7) Minority Development Department
        </Typography>
        <Typography fontSize={16} mt={2}>
          <b>
          B. Welfare schemes provided by the Maharashtra University of Health Sciences:
          </b>
        </Typography>
        <Typography fontSize={16}>
          1) Dhanvantari Vidyadhan Scheme;
        </Typography>
        <Typography fontSize={16}>
          2) Board of Extra Mural Studies Scheme;
        </Typography>
        <Typography fontSize={16}>
          3) Savitribai Phule Scholarship Scheme for Girl Students;
        </Typography>
        <Typography fontSize={16}>
          4) Sanjeevani Student Security Scheme;
        </Typography>
        <Typography fontSize={16}>
          5) Earn while Learn Scheme.
        </Typography>
        <Typography fontSize={16} mt={2}>
          <b>Disclaimer:</b> the above is only for information. For further details or procedures for application please visit the respective websites and do the needful.
        </Typography>
      </Stack>
    </Box>
  );
};

export default Scholarship;
